module.exports = __webpack_public_path__ + "static/media/kasumin.c6e5cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/pierna_negra_papa/curativa/kasumin.png
// module id = 2010
// module chunks = 3